import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { SnAbilityService } from '@lib/ability';
import { SnIncident, SnIncidentMedia } from '@lib/api/entities';
import { SnIncidentsAPI } from '@lib/api/services';

import { IncidentMediaDialogComponent } from '../../components/incident-media-dialog';

@Component({
  selector: 'sn-incident-media',
  templateUrl: './incident-media.container.html',
  styleUrls: ['./incident-media.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncidentMediaContainer implements OnInit, OnDestroy, OnChanges {
  @Input()
  public incident: SnIncident;

  @Input()
  public isChatExport: boolean = false;

  public media: SnIncidentMedia[] = [];
  public isLoading: boolean = false;
  public readonly canAdd: boolean;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _dialog: MatDialog,
    private readonly _incidentsAPI: SnIncidentsAPI,
    private readonly _cd: ChangeDetectorRef,
    ability: SnAbilityService,
  ) {
    this.canAdd = ability.can({ subject: 'vaults/incidentmedia', action: 'add' });
  }

  public ngOnChanges(): void {
    this._fetchData();
  }

  public ngOnInit(): void {
    this._fetchData();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public add(): void {
    const dialogRef = this._dialog.open(IncidentMediaDialogComponent, {
      data: this.incident,
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._destroy$))
      .subscribe(() => {
        this._fetchData();
      });
  }

  private _fetchData(): void {
    this.isLoading = true;
    this._incidentsAPI
      .getVaultIncident(this.incident.id)
      .pipe(takeUntil(this._destroy$))
      .subscribe((incident) => {
        this.isLoading = false;
        const description = 'chat channel export report';
        this.media = this.isChatExport
          ? incident.media?.filter((item) => item.description?.toLowerCase()?.includes(description))
          : incident.media?.filter(
              (item) => !item.description?.toLowerCase()?.includes(description),
            );
        this._cd.detectChanges();
      });
  }
}
